<div class="contact-support" #contactSupport data-section-id="contact-support-section" data-section-name="Contact Support">
  <app-container>
    <div class="contact-support__card">
      <!-- Desktop Layout -->
      <div class="contact-support__desktop-layout">
        <div class="contact-support__content">
          <h3 class="contact-support__title">Llámanos y un ejecutivo te ayudará de inmediato</h3>
          <div class="contact-support__phone">600 390 9000</div>
          <p class="contact-support__description">
            Recibe atención personalizada siempre que lo necesites
          </p>
        </div>
        <div class="contact-support__image-container">
          <img
            src="https://www.unipay.cl/api/descargaArchivo/web-PERRO-LLAMANDO-421x348.png"
            alt="Mascota Unipay"
            class="contact-support__image"
          />
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="contact-support__mobile-layout">
        <!-- Fila 1: Título (ocupa ambas columnas) -->
        <div class="contact-support__mobile-row contact-support__mobile-row--title">
          <h3 class="contact-support__title">Llámanos y un ejecutivo te ayudará de inmediato</h3>
        </div>
        
        <!-- Fila 2: Teléfono/Descripción (columna izquierda) y Imagen (columna derecha) -->
        <div class="contact-support__mobile-row contact-support__mobile-row--content">
          <!-- Columna Izquierda: Teléfono y Descripción -->
          <div class="contact-support__mobile-column contact-support__mobile-column--phone">
            <div class="contact-support__phone">600 390 9000</div>
            <p class="contact-support__description">
              Recibe atención personalizada siempre que lo necesites
            </p>
          </div>
          
          <!-- Columna Derecha: Imagen -->
          <div class="contact-support__mobile-column contact-support__mobile-column--image">
            <div class="contact-support__image-container">
              <img
                src="https://www.unipay.cl/api/descargaArchivo/web-PERRO-LLAMANDO-421x348.png"
                alt="Mascota Unipay"
                class="contact-support__image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-container>
</div>
